// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var ExternalLink = React.forwardRef(function ExternalLink(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ExternalLink" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M13.5 4H18.25L8 14.25L9.75 16L20 5.75V11L22.5 10.9846L22.5 1.5H13.5V4Z", fill: "currentColor" }),
            React.createElement("path", { d: "M11 4H2V22H20V14H17.5V19.5H4.5V6.5H11V4Z", fill: "currentColor" }))));
});
ExternalLink.displayName = 'ExternalLink';
export default ExternalLink;
//# sourceMappingURL=ExternalLink.js.map